export default __webpack_public_path__ + "static/2134-89e390d087b102dfe1d149e4c9243acc.gif";